import React from 'react'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from "gatsby"

import { TypographyStyle, GoogleFont } from 'react-typography'
import favicons from '../../utils/favicons'
import typography from '../../utils/typography'
import globalStyles from '../../utils/global-styles'
import '../layout.css';

export default class ReadyHelmet extends React.Component {
  render() {
    const { title, meta } = this.props;
    return (
        <Helmet
          title={title}
          meta={meta}
        >
          <html prefix="og: http://ogp.me/ns#"/>
          <TypographyStyle typography={typography} />
          <GoogleFont typography={typography} />
          <link rel="apple-touch-icon" sizes="180x180" href={favicons.appleTouchIcon}/>
          <link rel="icon" type="image/png" sizes="32x32" href={favicons.favicon32}/>
          <link rel="icon" type="image/png" sizes="16x16" href={favicons.favicon16}/>
        </Helmet>
      )
  }
};
